import { AlarmDefinitionsEditController, IAlarmDefinitionsEditScope } from './alarm-definitions-edit.directive.controller'
import { $SCOPE_SERVICE_NAME } from '../../../../services/system'

//#region Asset Imports

import './alarm-definitions-edit.scss'
import * as TEMPLATE from './alarm-definitions-edit.tpl.html'

//#endregion

export class AlarmDefinitionsEditDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        options: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        (
            $scope: IAlarmDefinitionsEditScope
        ) => {
            return new AlarmDefinitionsEditController($scope)
        }
    ]

    template = TEMPLATE
}
